import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { AlertService } from '../../exa/_services/alert.service';
import { AuthenticationService } from '../../_services/authentication.service';

import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Utils } from '../../utils';
import { DataContext } from '../../_models/data-context';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  loading = false;
  returnUrl: string;

  exaForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService) {

    // Annullo la sessione precedente
    Utils.removeUserContext();

    this.createForm();
  }

  createForm() {
    this.exaForm = new FormGroup({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });
  }


  ngOnInit() {
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  postLogin() {
    Utils.setDataContext(new DataContext());
    
    let uctx = Utils.getUserContext();

    if (uctx.pwdChangeRequired) {
      this.router.navigate(['/cambioPassword']);
    }
    else {
      this.router.navigate([this.returnUrl]);
    }
  }

  login() {
    this.alertService.clear();

    this.loading = true;
    this.authenticationService.login(this.exaForm.get('username').value, this.exaForm.get('password').value)
      .subscribe(
        data => {
          let uctx = Utils.getUserContext();
          if (uctx) {
            console.log('logged in');
            this.postLogin();
          }
          else {
            this.alertService.error('Credenziali non valide', 'error401');
            this.loading = false;
            console.error(data);
          }
         this.loading = false;
        },
        error => {
          if (error instanceof HttpErrorResponse) {
            switch (error.status) {
              case 401: // UNAUTHORIZED
                this.alertService.error('Credenziali non valide', 'error' + error.status);
                break;
              case 403: // FORBIDDEN
                this.alertService.error('Account temporaneamente bloccato, riprovare più tardi', 'error' + error.status);
                break;
              case 500: // Internal server error
                this.alertService.error('Internal server error', 'error' + error.status);
                console.error(error);
                break;
              default:
                this.alertService.error('Servizio non disponibile', 'error' + error.status);
                console.error(error);
            }
          } else {
            this.alertService.error('Si è verificato un errore imprevisto', 'errorUnexpected');
            console.error(error);
          }
          this.loading = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts